var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-1"},[_c('i',{staticClass:"icon-clock"}),_vm._v(" Valider les documents sélectionnés "),_c('button',{staticClass:"btn btn-success ml-2",on:{"click":_vm.sendAllDocuments}},[_vm._v(" Valider ")]),_c('button',{staticClass:"btn btn-danger ml-1",on:{"click":_vm.rejectAllDocuments}},[_vm._v(" Refuser ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }